import React, { useState, useMemo } from 'react';

import {
    TableCell,
    TableSortLabel,
} from "@mui/material";

const useSortHead = (defaultField) => {
    const [sortField, setSortField] = useState(defaultField);
    const [sortDirection, setSortDirection] = useState('asc');

    const handleSort = (field) => {
        let newDirection = 'asc';
        if (sortField === field) {
            if (sortDirection === 'asc') {
                newDirection = 'desc';
            } else {
                field = null;
            }
        }
        setSortField(field);
        setSortDirection(newDirection);
    };

    const TableCellSortHead = ({ field, children }) => (
        <TableCell>
            <TableSortLabel
                active={sortField === field}
                direction={sortDirection}
                onClick={() => handleSort(field)}
                sx={{
                    cursor: 'pointer',
                    '& .MuiTableSortLabel-icon': {
                        color: '#6600CC !important',
                    },
                }}
            >{children}</TableSortLabel>
        </TableCell>
    );

    const sortFunction = useMemo(() => (a, b) => {
        if (!sortField) return 0;
        const aValue = a[sortField];
        const bValue = b[sortField];
        if (aValue == null && bValue == null) return 0;
        if (aValue == null) return 1;
        if (bValue == null) return -1;
        if (aValue === bValue) return 0;
        const result = aValue > bValue ? 1 : -1;
        return sortDirection === 'asc' ? result : -result;
    }, [sortField, sortDirection]);

    return { TableCellSortHead, sortFunction };
};

export default useSortHead;
